(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-products"] && !Shopify.designMode) return;
  try {
    (function () {
    // ---- Delete button (moved from cart-product-card.liquid) ----
    // Dispatches quantity -> 0 THROUGH the existing quantity-selector /
    // cart-items-component pipeline, so removal gets the same section
    // morph as +/-, keeping price, free-shipping bar, and confetti tier
    // in sync with no separate network call.
    if (!window.__cartCardDeleteListenerAttached) {
      window.__cartCardDeleteListenerAttached = true;

      document.addEventListener('click', function (e) {
        var removeBtn = e.target.closest('[data-cart-remove]');
        if (!removeBtn) return;

        var card = removeBtn.closest('[data-cart-card]');
        if (!card) return;

        var selector = card.querySelector('cart-quantity-selector-component');
        if (!selector || typeof selector.setValue !== 'function' || typeof selector.onQuantityChange !== 'function') {
          return;
        }

        selector.setValue('0');
        selector.onQuantityChange();
      });
    }



    // ---- Inventory-aware quantity controls ----
    // Shopify's native quantity-selector remains responsible for cart updates.
    // This layer only disables +/- when the real variant inventory requires it.
    // Untracked inventory and variants set to continue selling remain unlimited.
    if (!window.__cartQuantityInventoryGuardV2) {
      window.__cartQuantityInventoryGuardV2 = true;

      var inventoryCache = window.__cartVariantInventoryCacheV2 || (window.__cartVariantInventoryCacheV2 = {});
      var inventoryRefreshTimer = null;

      var syncQuantityButtons = function () {
        var selectors = document.querySelectorAll('cart-quantity-selector-component');

        for (var i = 0; i < selectors.length; i++) {
          var wrapper = selectors[i];
          var input = wrapper.querySelector('.cart-card__qty-value, input[type="number"]');
          if (!input) continue;

          var quantity = Number(input.value);
          var minimum = Number(input.getAttribute('min'));
          var nativeMaximum = Number(input.getAttribute('max'));
          if (!Number.isFinite(minimum)) minimum = 1;
          if (!Number.isFinite(quantity)) quantity = minimum;

          var minusButton = wrapper.querySelector('.cart-card__qty-minus');
          if (minusButton) {
            var disableMinus = quantity <= minimum;
            minusButton.disabled = disableMinus;
            minusButton.setAttribute('aria-disabled', disableMinus ? 'true' : 'false');
          }

          var plusButton = wrapper.querySelector('.cart-card__qty-plus');
          if (plusButton) {
            var inventoryMaximum = Number(wrapper.dataset.inventoryMax || '');
            var inventoryTracked = wrapper.dataset.inventoryTracked === 'true';
            var inventoryPolicy = wrapper.dataset.inventoryPolicy || 'deny';
            var hasInventoryMaximum = inventoryTracked && inventoryPolicy === 'deny' && Number.isFinite(inventoryMaximum) && inventoryMaximum >= 0;

            // If inventory is NOT tracked, the product is intentionally unlimited
            // from this guard's point of view. Do not let a stale/native max=1
            // disable the + button for an untracked variant.
            if (!inventoryTracked || inventoryPolicy === 'continue') {
              input.removeAttribute('max');
            } else if (hasInventoryMaximum) {
              // Never set an HTML max below the quantity that is already in the cart.
              // Otherwise a valid cart line (for example quantity 1 with current
              // inventory 0) becomes an invalid number input and blocks the
              // checkout form with: "Minimum value (1) must be less than the
              // maximum value (0)." Shopify can still validate inventory at
              // checkout; this guard should only control the + button.
              input.setAttribute('max', String(Math.max(inventoryMaximum, quantity)));
            }

            nativeMaximum = Number(input.getAttribute('max'));
            var nativeMaxReached = hasInventoryMaximum && Number.isFinite(nativeMaximum) && quantity >= nativeMaximum;
            var inventoryMaxReached = hasInventoryMaximum && quantity >= inventoryMaximum;
            var disablePlus = inventoryMaxReached || nativeMaxReached;

            plusButton.disabled = disablePlus;
            plusButton.setAttribute('aria-disabled', disablePlus ? 'true' : 'false');
          }
        }
      };

      var refreshInventoryLimits = function () {
        fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/') + 'cart.js', { credentials: 'same-origin' })
          .then(function (response) {
            if (!response.ok) throw new Error('Cart request failed');
            return response.json();
          })
          .then(function (cart) {
            if (!cart || !Array.isArray(cart.items)) {
              syncQuantityButtons();
              return;
            }

            var selectors = document.querySelectorAll('cart-quantity-selector-component');
            var requests = [];

            // Cart line order and quantity-selector order are both generated from
            // the same cart line collection, so matching by index avoids depending
            // on theme-specific variant data attributes.
            for (var i = 0; i < cart.items.length && i < selectors.length; i++) {
              (function (item, wrapper) {
                var variantId = String(item.variant_id || '');
                var handle = item.handle;
                if (!variantId || !handle) return;

                var cached = inventoryCache[variantId];
                if (cached) {
                  wrapper.dataset.inventoryTracked = cached.tracked ? 'true' : 'false';
                  wrapper.dataset.inventoryPolicy = cached.policy || 'deny';
                  if (cached.tracked && cached.policy === 'deny' && Number.isFinite(cached.available)) {
                    var currentQty = Number((wrapper.querySelector('.cart-card__qty-value, input[type="number"]') || {}).value);
                    if (!Number.isFinite(currentQty)) currentQty = 1;
                    wrapper.dataset.inventoryMax = String(Math.max(0, cached.available, currentQty));
                  } else {
                    delete wrapper.dataset.inventoryMax;
                  }
                  return;
                }

                requests.push(
                  fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
                    .then(function (response) {
                      if (!response.ok) throw new Error('Product request failed');
                      return response.json();
                    })
                    .then(function (product) {
                      var variants = Array.isArray(product.variants) ? product.variants : [];
                      var variant = null;

                      for (var v = 0; v < variants.length; v++) {
                        if (String(variants[v].id) === variantId) {
                          variant = variants[v];
                          break;
                        }
                      }

                      if (!variant) return;

                      var tracked = !!variant.inventory_management;
                      var policy = variant.inventory_policy || 'deny';
                      var available = Number(variant.inventory_quantity);

                      inventoryCache[variantId] = {
                        tracked: tracked,
                        policy: policy,
                        available: Number.isFinite(available) ? available : NaN
                      };

                      wrapper.dataset.inventoryTracked = tracked ? 'true' : 'false';
                      wrapper.dataset.inventoryPolicy = policy;

                      if (tracked && policy === 'deny' && Number.isFinite(available)) {
                        // Use inventory as the + button limit, but never create an
                        // invalid HTML max below the quantity already in the cart.
                        var currentQty = Number((wrapper.querySelector('.cart-card__qty-value, input[type="number"]') || {}).value);
                        if (!Number.isFinite(currentQty)) currentQty = 1;
                        wrapper.dataset.inventoryMax = String(Math.max(0, available, currentQty));
                      } else {
                        // Untracked / continue-selling variants are unlimited here.
                        delete wrapper.dataset.inventoryMax;
                      }
                    })
                    .catch(function () {
                      // If inventory cannot be resolved, do not invent a limit.
                      // Let Shopify's native selector/cart validation handle it.
                      delete wrapper.dataset.inventoryMax;
                      delete wrapper.dataset.inventoryTracked;
                      delete wrapper.dataset.inventoryPolicy;
                    })
                );
              })(cart.items[i], selectors[i]);
            }

            if (requests.length) {
              Promise.allSettled(requests).then(syncQuantityButtons);
            } else {
              syncQuantityButtons();
            }
          })
          .catch(syncQuantityButtons);
      };

      var scheduleInventoryRefresh = function () {
        window.cancelAnimationFrame(inventoryRefreshTimer);
        inventoryRefreshTimer = window.requestAnimationFrame(function () {
          refreshInventoryLimits();
        });
      };

      document.addEventListener('input', function (event) {
        if (event.target && event.target.matches && event.target.matches('cart-quantity-selector-component .cart-card__qty-value, cart-quantity-selector-component input[type="number"]')) {
          syncQuantityButtons();
        }
      });

      document.addEventListener('change', function (event) {
        if (event.target && event.target.matches && event.target.matches('cart-quantity-selector-component .cart-card__qty-value, cart-quantity-selector-component input[type="number"]')) {
          scheduleInventoryRefresh();
        }
      });

      var quantityObserver = new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          if (mutations[i].type === 'childList' && mutations[i].addedNodes.length) {
            scheduleInventoryRefresh();
            return;
          }
        }
      });

      quantityObserver.observe(document.body, { childList: true, subtree: true });
      scheduleInventoryRefresh();
    }

    // ---- Free-shipping / rewards confetti ----
    // One celebration for EACH reward that is newly unlocked:
    // 0 -> 1 = Free Shipping
    // 1 -> 2 = 5% OFF
    // 2 -> 3 = 10% OFF
    // If the cart jumps across multiple thresholds in one update, every
    // crossed reward gets its own celebration wave.
    if (!window.__cartProgressConfettiInitV5) {
      window.__cartProgressConfettiInitV5 = true;

      var STORAGE_KEY = 'cartProgressTierV5';
      var confettiColors = [
        '#00675b', '#0d806f', '#d8ae43', '#df7a61',
        '#3d9a8b', '#efd08d', '#bd5650', '#78a9a2'
      ];
      var shapeVariants = ['rect', 'strip', 'triangle', 'irregular'];

      var randomBetween = function (min, max) {
        return min + Math.random() * (max - min);
      };

      var prefersReducedMotion = function () {
        return window.matchMedia &&
          window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      };

      var spawnConfetti = function (progressEl, waveNumber) {
        if (prefersReducedMotion() || !progressEl) return;

        var root = progressEl.closest('.cart-items__wrapper');
        if (!root) return;

        var host = root.querySelector(':scope > .cart-progress__confetti');
        if (!host) return;

        var rect = host.getBoundingClientRect();
        if (!rect.width) return;

        /*
         * Keep all three celebrations in the same cart-local layer.
         * waveNumber slightly changes the launch position so the 3 rewards
         * feel like three separate bursts instead of one giant explosion.
         */
        var launchOffset = waveNumber === 1
          ? randomBetween(-rect.width * 0.12, rect.width * 0.12)
          : waveNumber === 2
            ? randomBetween(-rect.width * 0.20, rect.width * 0.20)
            : randomBetween(-rect.width * 0.28, rect.width * 0.28);

        var pieceCount = Math.min(
          105,
          Math.max(78, Math.round(rect.width / 3.8))
        );

        for (var i = 0; i < pieceCount; i++) {
          var piece = document.createElement('span');
          var shape = shapeVariants[
            Math.floor(Math.random() * shapeVariants.length)
          ];
          var color = confettiColors[
            Math.floor(Math.random() * confettiColors.length)
          ];

          piece.className =
            'cart-progress__confetti-piece cart-progress__confetti-piece--' + shape;

          var startX = launchOffset +
            randomBetween(-rect.width * 0.46, rect.width * 0.46);
          var midX = randomBetween(-28, 28);
          var dx = randomBetween(-62, 62);

          piece.style.left = '50%';

          var width;
          var height;

          if (shape === 'strip') {
            width = randomBetween(2, 3.5);
            height = randomBetween(7, 13);
          } else if (shape === 'triangle') {
            var triSize = randomBetween(5, 8);
            piece.style.borderLeft =
              (triSize / 2) + 'px solid transparent';
            piece.style.borderRight =
              (triSize / 2) + 'px solid transparent';
            piece.style.borderBottom =
              triSize + 'px solid ' + color;
          } else if (shape === 'irregular') {
            width = randomBetween(4, 8);
            height = randomBetween(4, 8);
          } else {
            width = randomBetween(3, 7);
            height = randomBetween(5, 10);
          }

          if (shape !== 'triangle') {
            piece.style.width = width + 'px';
            piece.style.height = height + 'px';
            piece.style.background = color;
          }

          var midY = randomBetween(72, 135);
          var minEnd = Math.min(
            300,
            Math.max(245, rect.height * 0.60)
          );
          var maxEnd = Math.max(330, rect.height - 8);
          var dy = randomBetween(minEnd, maxEnd);
          var rot = randomBetween(280, 700) *
            (Math.random() < 0.5 ? -1 : 1);
          var midRot = randomBetween(80, 190) *
            (Math.random() < 0.5 ? -1 : 1);

          piece.style.setProperty('--cp-start-x', startX + 'px');
          piece.style.setProperty('--cp-mid-x', midX + 'px');
          piece.style.setProperty('--cp-mid-y', midY + 'px');
          piece.style.setProperty('--cp-mid-rot', midRot + 'deg');
          piece.style.setProperty('--cp-dx', dx + 'px');
          piece.style.setProperty('--cp-dy', dy + 'px');
          piece.style.setProperty('--cp-rot', rot + 'deg');

          piece.style.animationDuration =
            randomBetween(2.35, 3.35) + 's';

          /*
           * Each reward gets its own wave:
           * wave 1 starts immediately,
           * wave 2 follows shortly,
           * wave 3 follows after that.
           */
          var baseDelay = waveNumber === 1
            ? 0
            : waveNumber === 2
              ? 0.42
              : 0.84;

          piece.style.animationDelay =
            (baseDelay + randomBetween(0, 0.45)) + 's';

          host.appendChild(piece);
        }
      };

      var celebrateCrossedRewards = function (progressEl, oldTier, newTier) {
        if (!progressEl || newTier <= oldTier) return;

        var crossed = newTier - oldTier;

        /*
         * 3 -> 0 never happens here because this is only called for upward
         * changes. A direct jump 0 -> 3 therefore produces three waves.
         */
        for (var i = 1; i <= crossed; i++) {
          (function (wave) {
            window.setTimeout(function () {
              spawnConfetti(progressEl, wave);
            }, (wave - 1) * 420);
          })(i);
        }

        window.setTimeout(function () {
          var root = progressEl.closest('.cart-items__wrapper');
          var host = root &&
            root.querySelector(':scope > .cart-progress__confetti');

          if (host) host.innerHTML = '';
        }, 4800 + (crossed * 250));
      };

      var checkTierChange = function (progressEl) {
        var tier =
          parseInt(progressEl.getAttribute('data-current-tier'), 10) || 0;

        var storedRaw = sessionStorage.getItem(STORAGE_KEY);

        if (storedRaw === null) {
          sessionStorage.setItem(STORAGE_KEY, String(tier));
          return;
        }

        var storedTier = parseInt(storedRaw, 10) || 0;

        if (tier > storedTier) {
          celebrateCrossedRewards(progressEl, storedTier, tier);
        }

        /*
         * Always sync the stored tier, including downward changes.
         * This means if the shopper goes from 3 back to 0 and later climbs
         * through the rewards again, each reward celebrates again.
         */
        if (tier !== storedTier) {
          sessionStorage.setItem(STORAGE_KEY, String(tier));
        }
      };

      var findProgress = function () {
        return document.querySelector(
          '.cart-progress[data-current-tier]'
        );
      };

      var initialEl = findProgress();
      if (initialEl) checkTierChange(initialEl);

      var runTierCheck = function () {
        if (window.__cartProgressObserverFrameV7) return;

        window.__cartProgressObserverFrameV7 =
          window.requestAnimationFrame(function () {
            window.__cartProgressObserverFrameV7 = null;

            var el = findProgress();
            if (el) checkTierChange(el);
          });
      };

      /*
       * IMPORTANT:
       * Do not stop watching after the first cart render.
       *
       * When the cart starts empty, .cart-items__wrapper does not exist yet.
       * When Shopify later adds the first product, it can also replace the
       * cart section. A short retry loop is therefore not reliable.
       *
       * This stable document-level observer watches for the cart section to
       * appear/reappear and also catches data-current-tier changes after
       * every add, quantity change, remove, and section morph.
       */
      var documentCartObserver = new MutationObserver(function (mutations) {
        var shouldCheck = false;

        for (var i = 0; i < mutations.length; i++) {
          var mutation = mutations[i];

          if (mutation.type === 'childList') {
            shouldCheck = true;
            break;
          }

          if (
            mutation.type === 'attributes' &&
            mutation.attributeName === 'data-current-tier'
          ) {
            shouldCheck = true;
            break;
          }
        }

        if (shouldCheck) runTierCheck();
      });

      documentCartObserver.observe(document.documentElement, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['data-current-tier']
      });

      /*
       * Check immediately on initial page load.
       */
      runTierCheck();

      /*
       * Also expose a tiny helper so any Shopify cart section replacement
       * can explicitly request a tier check without needing another page load.
       */
      window.__refreshCartRewardTierV7 = runTierCheck;
    }
  })();

  (function () {
    // ---- Inline coupons ----
    // Available coupons are read ONLY from shop.metafields.custom.available_coupons.
    // The same handler is used for a coupon card and the manual code field.
    if (!window.__inlineCouponCardsInitV3) {
      window.__inlineCouponCardsInitV3 = true;

      var getCartSectionId = function () {
        var host = document.querySelector('cart-items-component[data-section-id]');
        return host ? host.getAttribute('data-section-id') : null;
      };

      var getCurrentCart = function () {
        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        return fetch(root + 'cart.js', { credentials: 'same-origin' })
          .then(function (res) {
            if (!res.ok) throw new Error('Cart read failed: ' + res.status);
            return res.json();
          });
      };

      var swapInFreshSectionHtml = function (html) {
        if (!html) return;

        var doc = new DOMParser().parseFromString(html, 'text/html');
        var liveItems = document.querySelector('.cart-items__wrapper');
        var freshItems = doc.querySelector('.cart-items__wrapper');

        if (freshItems && liveItems) {
          liveItems.innerHTML = freshItems.innerHTML;
        }

        var liveSummary = document.querySelector('.cart-drawer__summary');
        var freshSummary = doc.querySelector('.cart-drawer__summary');

        if (freshSummary && liveSummary) {
          liveSummary.innerHTML = freshSummary.innerHTML;
        }

        // Refresh the coupon area too, so automatic discounts and newly
        // applied discount codes appear immediately in the same UI.
        var liveCoupons = document.querySelector('.cart-coupons-wrapper');
        var freshCoupons = doc.querySelector('.cart-coupons-wrapper');

        if (freshCoupons && liveCoupons) {
          liveCoupons.innerHTML = freshCoupons.innerHTML;
        }
      };

      var updateDiscount = function (discountValue) {
        var sectionId = getCartSectionId();
        var body = { discount: discountValue };
        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

        if (sectionId) {
          body.sections = sectionId;
          body.sections_url = window.location.pathname;
        }

        return fetch(root + 'cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(body),
        })
          .then(function (res) {
            return res.json().then(function (data) {
              if (!res.ok) {
                var message = data && (data.description || data.message);
                throw new Error(message || ('Coupon request failed: ' + res.status));
              }
              return data;
            });
          })
          .then(function (data) {
            if (sectionId && data.sections && data.sections[sectionId]) {
              swapInFreshSectionHtml(data.sections[sectionId]);
            }
            return data;
          });
      };

      var copyText = function (text) {
        if (!text) return Promise.resolve();

        if (navigator.clipboard && navigator.clipboard.writeText) {
          return navigator.clipboard.writeText(text).catch(function () {
            var textarea = document.createElement('textarea');
            textarea.value = text;
            textarea.style.position = 'fixed';
            textarea.style.opacity = '0';
            document.body.appendChild(textarea);
            textarea.focus();
            textarea.select();
            try { document.execCommand('copy'); } catch (err) {}
            document.body.removeChild(textarea);
          });
        }

        var textarea = document.createElement('textarea');
        textarea.value = text;
        textarea.style.position = 'fixed';
        textarea.style.opacity = '0';
        document.body.appendChild(textarea);
        textarea.focus();
        textarea.select();
        try { document.execCommand('copy'); } catch (err) {}
        document.body.removeChild(textarea);
        return Promise.resolve();
      };

      var setMessage = function (message, isError) {
        var messageEl = document.querySelector('[data-inline-coupon-message]');
        if (!messageEl) return;
        messageEl.textContent = message || '';
        messageEl.style.color = isError ? '#b3261e' : '#4c7c68';
      };

      var hasAppliedDiscount = function (cart, beforeCart) {
        if (!cart) return false;

        if (Number(cart.total_discount || 0) > Number(beforeCart && beforeCart.total_discount || 0)) {
          return true;
        }

        if (Array.isArray(cart.cart_level_discount_applications) && cart.cart_level_discount_applications.length) {
          return true;
        }

        if (Array.isArray(cart.items)) {
          for (var i = 0; i < cart.items.length; i++) {
            var item = cart.items[i];
            if (Number(item.line_level_total_discount || 0) > 0) return true;
            if (Array.isArray(item.line_level_discount_allocations) && item.line_level_discount_allocations.length) {
              return true;
            }
          }
        }

        return false;
      };

      var removeAppliedCoupon = function (buttonEl) {
        if (buttonEl) buttonEl.disabled = true;
        setMessage('Removing coupon…', false);

        return updateDiscount('')
          .then(function () {
            return getCurrentCart();
          })
          .then(function (cart) {
            if (hasAppliedDiscount(cart, null)) {
              setMessage('This discount is applied automatically and cannot be removed manually.', true);
              return;
            }

            setMessage('Coupon removed. Available coupons are shown again.', false);
          })
          .catch(function (error) {
            console.error('Coupon remove failed:', error);
            setMessage(error && error.message ? error.message : 'Unable to remove coupon.', true);
          })
          .finally(function () {
            if (buttonEl && buttonEl.isConnected) buttonEl.disabled = false;
          });
      };

      var applyCoupon = function (code, buttonEl, messageMode) {
        var trimmed = (code || '').trim().toUpperCase();
        if (!trimmed) {
          if (messageMode) setMessage('Please enter a coupon code.', true);
          return Promise.reject(new Error('Empty coupon code'));
        }

        if (buttonEl) buttonEl.disabled = true;
        if (messageMode) setMessage('Checking coupon…', false);

        return getCurrentCart()
          .then(function (beforeCart) {
            return copyText(trimmed)
              .then(function () {
                return updateDiscount(trimmed);
              })
              .then(function (updateResult) {
                // Shopify's Cart AJAX API accepts { discount: 'CODE' } on
                // /cart/update.js. We then read the cart again so we can
                // distinguish a real applied discount from a code that is
                // invalid, inactive, or currently not eligible.
                return getCurrentCart().then(function (afterCart) {
                  if (!hasAppliedDiscount(afterCart, beforeCart)) {
                    throw new Error('Coupon is invalid or not applicable to this cart.');
                  }

                  return updateResult;
                });
              });
          })
          .then(function () {
            setMessage('Coupon applied successfully. Your cart total has been updated.', false);

            document.querySelectorAll('[data-inline-coupon-apply]').forEach(function (btn) {
              var btnCode = (btn.getAttribute('data-coupon-code') || '').trim().toUpperCase();
              if (btnCode === trimmed) {
                var textEl = btn.querySelector('.cart-coupon-card__copy-text');
                if (textEl) textEl.textContent = 'APPLIED';
              }
            });

            return true;
          })
          .catch(function (err) {
            console.error('Coupon apply failed:', err);
            setMessage('Enter a valid active coupon code that applies to your cart.', true);
            throw err;
          })
          .finally(function () {
            if (buttonEl && buttonEl.isConnected) buttonEl.disabled = false;
          });
      };

      document.addEventListener('click', function (e) {
        var removeButton = e.target.closest('[data-inline-coupon-remove]');
        if (removeButton) {
          e.preventDefault();
          e.stopPropagation();
          removeAppliedCoupon(removeButton);
          return;
        }

        var button = e.target.closest('[data-inline-coupon-apply]');
        if (!button) return;

        var code = button.getAttribute('data-coupon-code') || '';
        applyCoupon(code, button, true).catch(function () {});
      });

      document.addEventListener('submit', function (e) {
        var form = e.target.closest('[data-inline-coupon-form]');
        if (!form) return;

        e.preventDefault();

        var input = form.querySelector('[data-inline-coupon-input]');
        var submit = form.querySelector('[data-inline-coupon-submit]');
        var code = input ? input.value.trim() : '';

        applyCoupon(code, submit, true)
          .then(function () {
            if (input) input.value = '';
          })
          .catch(function () {});
      });
    }
  })();
  (function () {
    // ---- Cart summary expand/collapse (moved from cart-summary.liquid) ----
    if (!window.__cartSummaryToggleInit) {
      window.__cartSummaryToggleInit = true;

      document.addEventListener('click', function (e) {
        var toggle = e.target.closest('[data-cart-summary-toggle]');
        if (!toggle) return;

        var targetId = toggle.getAttribute('aria-controls');
        var panel = targetId ? document.getElementById(targetId) : null;
        if (!panel) return;

        var isExpanded = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', isExpanded ? 'false' : 'true');
        panel.hidden = isExpanded;
      });
    }
  })();

  /*
   * MOBILE BACK / BFCACHE SAFETY V7
   *
   * Some mobile browsers restore a Shopify dialog together with the document's
   * old scroll lock. The first back can look fine, but opening the cart again
   * and swiping back may leave html/body locked on the second BFCache restore.
   * Clean the lock both before the page is cached and after it is restored.
   *
   * V6 FIX: V5 only cleared the lock on document.documentElement and
   * document.body. But per this file's own CSS, .cart-drawer__content is
   * "the ONE REAL SCROLL CONTAINER" for vertical scrolling inside the
   * drawer — html/body are not what actually scrolls. If a BFCache
   * restore leaves a stale inline style or a stuck touch-action on
   * .cart-drawer__content (or on the <scroll-hint> custom element
   * wrapping .cart-drawer__items), vertical scrolling breaks while
   * horizontal sliders elsewhere on the page (.lc-uslider,
   * .cart-coupons__scroll — separate, self-contained overflow-x boxes
   * that were never part of any lock) keep working fine.
   *
   * V7 FIX: swipe-back closing the drawer turned out NOT to be a
   * pageshow/pagehide/BFCache situation at all in practice — closing
   * the drawer normally (tap the close button) worked fine, but
   * swipe-back specifically stayed broken even after V6. That points
   * to the drawer being closed via a `popstate` event (many cart
   * drawers push a history entry on open specifically so back/swipe
   * closes the drawer instead of navigating away), which never fires
   * pageshow or pagehide since the page itself never unloads or gets
   * BFCache-restored. V7 adds a direct `popstate` listener that runs
   * the same recovery regardless of how the drawer's own close logic
   * is wired.
   */
  (function () {
    if (window.__cartDrawerScrollRecoveryV7) return;
    window.__cartDrawerScrollRecoveryV7 = true;

    function getScrollTargets() {
      var targets = [document.documentElement, document.body];

      var content = document.querySelector('.cart-drawer__content');
      if (content) targets.push(content);

      var items = document.querySelector('scroll-hint.cart-drawer__items, .cart-drawer__items');
      if (items) targets.push(items);

      return targets;
    }

    function clearPageScrollLock() {
      var targets = getScrollTargets();

      targets.forEach(function (el) {
        if (!el) return;
        [
          'overflow', 'overflow-y', 'overflow-x',
          'position', 'touch-action', 'overscroll-behavior',
          'overscroll-behavior-y', 'overscroll-behavior-x',
          'pointer-events', 'height', 'max-height'
        ].forEach(function (prop) {
          el.style.removeProperty(prop);
        });

        el.classList.remove('overflow-hidden', 'scroll-locked', 'no-scroll');
      });

      // Re-assert the drawer's own scroll container as scrollable —
      // don't just remove inline styles and hope the stylesheet rule
      // wins; on some mobile browsers a BFCache restore keeps the
      // compositor's stale "this layer doesn't scroll" state until an
      // element's OWN scrolling properties are actively re-written.
      var content = document.querySelector('.cart-drawer__content');
      if (content) {
        content.style.overflowY = 'auto';
        content.style.overflowX = 'hidden';
        content.style.webkitOverflowScrolling = 'touch';
        content.style.touchAction = 'pan-y';
        // Force a reflow so the browser recalculates scrollability
        // immediately instead of on the next unrelated layout pass.
        void content.offsetHeight;
      }

      var items = document.querySelector('scroll-hint.cart-drawer__items, .cart-drawer__items');
      if (items) {
        items.style.touchAction = 'pan-y';
        void items.offsetHeight;
      }
    }

    function closeStaleCartDrawer() {
      var drawer = document.querySelector('cart-drawer');
      if (!drawer) return;

      try {
        if (typeof drawer.close === 'function') drawer.close();
      } catch (e) {}

      var dialog = drawer.querySelector('dialog[open]');
      if (dialog && typeof dialog.close === 'function') {
        try { dialog.close(); } catch (e) {}
      }

      // Some theme versions keep an open attribute/class briefly after close().
      if (dialog) dialog.removeAttribute('open');
      drawer.removeAttribute('open');
    }

    function recoverPageScroll() {
      clearPageScrollLock();
      window.setTimeout(clearPageScrollLock, 30);
      window.setTimeout(clearPageScrollLock, 120);
      window.setTimeout(clearPageScrollLock, 300);
      window.setTimeout(function () {
        window.dispatchEvent(new Event('resize'));
        window.dispatchEvent(new Event('scroll'));
      }, 60);
    }

    function onPageShow(event) {
      if (event && event.persisted) {
        closeStaleCartDrawer();
        recoverPageScroll();
        return;
      }

      // A normal history return can also restore a stale lock in some Chrome
      // versions, so only clear it when the cart is not currently open.
      var openDialog = document.querySelector('cart-drawer dialog[open]');
      if (!openDialog) recoverPageScroll();
    }

    function onPageHide(event) {
      if (!event || !event.persisted) return;
      // Release the lock BEFORE BFCache snapshots the page. This prevents the
      // second swipe-back from restoring a frozen vertical scroll surface.
      closeStaleCartDrawer();
      clearPageScrollLock();
    }

    window.addEventListener('pageshow', onPageShow, false);
    window.addEventListener('pagehide', onPageHide, false);

    // V7 FIX: swipe-back on mobile (and a plain tap of the hardware/
    // browser back button) very likely closes this drawer through a
    // `popstate` event, not a real page unload — many cart drawers push
    // a history entry when they open specifically so back/swipe closes
    // the drawer instead of navigating away. That path NEVER fires
    // pageshow or pagehide (the page never actually unloads or gets
    // BFCache-restored — it's a same-page history pop), so everything
    // above this line simply never ran for that case. This is why a
    // normal tap on the close button worked fine (it goes through
    // whatever in-page close logic already cleans up correctly) while
    // swipe-back specifically stayed broken. Clearing the lock here,
    // directly on popstate, covers that gap regardless of how the
    // drawer's own close logic is wired.
    //
    // V8 FIX: the on-screen debug panel confirmed the actual cause —
    // document.body is left with `position: fixed` after a real
    // swipe-back (the standard technique for locking the background
    // page while a drawer is open, normally undone by whatever code
    // closes the drawer — which the popstate path skips).
    //
    // V9 FIX: real-device testing showed the FIRST swipe-back still
    // froze scroll, but a SECOND swipe-back fixed it. That means the
    // V8 correction was landing too early and too briefly — either the
    // theme's own closing animation/cleanup takes longer than V8's
    // 1.5s window and re-imposes the lock again right after V8 gave up,
    // or the actual trigger is an attribute change on <cart-drawer>
    // itself (a `body:has(cart-drawer[open]) { position: fixed }`-style
    // rule is common in modern themes) rather than a mutation on body
    // directly, which V8's body-only MutationObserver would never see.
    // Two changes:
    // 1) Watch attribute changes anywhere in the document (not just on
    //    body) — this catches an [open] attribute or class toggling on
    //    <cart-drawer>, <dialog>, or any wrapper, regardless of which
    //    element the theme actually flips.
    // 2) Replace the handful of fixed-delay checkpoints with a tight
    //    100ms polling loop that keeps fighting for a full 5 seconds
    //    after popstate — long enough to outlast any slow real-device
    //    closing animation — instead of guessing an exact timing.
    var popstateGuardUntil = 0;
    var popstatePollTimer = null;

    function stripBodyFixedLock() {
      // Check BOTH <html> and <body> — in most browsers, <html>
      // (document.documentElement) is the element that actually
      // controls page-level scrolling, not <body>. A screenshot showed
      // body correctly reset to position:static after a swipe-back,
      // yet the page still wouldn't scroll — which only makes sense if
      // the real lock is sitting on <html> instead, and this function
      // was never checking that element at all until now.
      [document.documentElement, document.body].forEach(function (el) {
        if (!el) return;

        var computedPosition = window.getComputedStyle(el).position;
        var computedOverflowY = window.getComputedStyle(el).overflowY;

        if (
          el.style.position === 'fixed' || computedPosition === 'fixed' ||
          computedOverflowY === 'hidden'
        ) {
          // Force-override with !important so this wins regardless of
          // where the lock is actually coming from (inline style, CSS
          // class, or a :has()-style rule reacting to another element).
          el.style.setProperty('position', 'static', 'important');
          el.style.setProperty('top', 'auto', 'important');
          el.style.setProperty('left', 'auto', 'important');
          el.style.setProperty('width', 'auto', 'important');
          el.style.setProperty('overflow', 'visible', 'important');
          el.style.setProperty('overflow-y', 'auto', 'important');
          el.style.setProperty('height', 'auto', 'important');
        }
      });
    }

    // Watches the WHOLE document, not just body, so it catches whatever
    // element actually triggers the lock (an [open] attribute or class
    // toggling on <cart-drawer> or similar), even if body itself is
    // never directly mutated.
    var bodyLockObserver = new MutationObserver(function () {
      if (Date.now() > popstateGuardUntil) return;
      stripBodyFixedLock();
    });

    bodyLockObserver.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['style', 'class', 'open'],
      subtree: true
    });

    window.addEventListener('popstate', function () {
      popstateGuardUntil = Date.now() + 5000;

      // Run immediately, don't wait for the first poll tick.
      clearPageScrollLock();
      stripBodyFixedLock();

      if (popstatePollTimer) window.clearInterval(popstatePollTimer);

      popstatePollTimer = window.setInterval(function () {
        if (Date.now() > popstateGuardUntil) {
          window.clearInterval(popstatePollTimer);
          popstatePollTimer = null;
          return;
        }
        stripBodyFixedLock();
      }, 100);

      // Still run the fuller cleanup (drawer content, scroll-hint, etc.)
      // at a few checkpoints too, not just the body-position fight.
      window.setTimeout(clearPageScrollLock, 300);
      window.setTimeout(clearPageScrollLock, 1000);
      window.setTimeout(clearPageScrollLock, 2500);
      window.setTimeout(clearPageScrollLock, 4900);
    }, false);

    // Chrome/iOS can restore the page through visibility changes without a
    // conventional pageshow in a few navigation paths.
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') {
        window.setTimeout(function () {
          var openDialog = document.querySelector('cart-drawer dialog[open]');
          if (!openDialog) recoverPageScroll();
        }, 50);
      }
    }, false);

    // Also cover the in-page case: closing the cart drawer normally
    // (tap the close button / backdrop) rather than via browser back.
    // If a previous swipe-back left a lock behind, it can otherwise
    // persist silently until the NEXT full page navigation.
    document.addEventListener('click', function (e) {
      if (e.target.closest('.cart-drawer__close-button, [data-cart-drawer-close]')) {
        window.setTimeout(clearPageScrollLock, 250);
      }
    }, false);
  })();
  } catch(e) { console.error(e); }
})();

})();
